module.exports = __webpack_public_path__ + "static/media/lighter.710d46d8.png";